import { useCallback, useEffect, useRef, useState } from 'react';

export function useTimer({
    initialTime = 0, // saniye cinsinden
    direction = 'down', // 'down' veya 'up'
    onComplete = null
}) {
    const [timeLeft, setTimeLeft] = useState(initialTime);
    const [isActive, setIsActive] = useState(false);
    const intervalRef = useRef(null);

    useEffect(() => {
        if (isActive) {
            intervalRef.current = setInterval(() => {
                setTimeLeft((prev) => {
                    const nextValue = direction === 'down' ? prev - 1 : prev + 1;

                    // Geri sayımda 0'a ulaştığında
                    if (direction === 'down' && nextValue <= 0) {
                        setIsActive(false);
                        if (onComplete) {
                            onComplete();
                        }
                        return 0;
                    }

                    return nextValue;
                });
            }, 1000);
        } else {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        }

        return () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
            }
        };
    }, [isActive, direction, onComplete]);

    const start = useCallback(() => {
        setIsActive(true);
    }, []);

    const pause = useCallback(() => {
        setIsActive(false);
    }, []);

    const reset = useCallback(() => {
        setIsActive(false);
        setTimeLeft(initialTime);
    }, [initialTime]);

    const restart = useCallback(() => {
        setTimeLeft(initialTime);
        setIsActive(true);
    }, [initialTime]);

    const setTime = useCallback((newTime) => {
        setTimeLeft(newTime);
    }, []);

    const formatTime = useCallback((seconds) => {
        const hours = Math.floor(seconds / 3600);
        const mins = Math.floor((seconds % 3600) / 60);
        const secs = seconds % 60;

        if (hours > 0) {
            return `${hours.toString().padStart(2, '0')}:${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
        }
        return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
    }, []);

    return {
        timeLeft,
        isActive,
        start,
        pause,
        reset,
        restart,
        setTime,
        formatTime: () => formatTime(timeLeft)
    };
}